// extracted by mini-css-extract-plugin
var _1 = "EntityTabAttributesGroup-modulegroup__nOfAp";
var _2 = "EntityTabAttributesGroup-modulegroupContent__eXAQs";
var _3 = "EntityTabAttributesGroup-modulegroupTitle__k8WES";
export { _1 as "group", _2 as "groupContent", _3 as "groupTitle" }
